import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => { 
  return (
    <>
      <div className=" sidebar-mini layout-fixed">
        <div className="wrapper">
          <nav className="main-header navbar navbar-expand ">
            {/* <ul className="navbar-nav">
              <li className="nav-item"> 
                <a className="nav-link" data-widget="pushmenu" href="#" role="button">
                  <i className="fas fa-bars" />
                </a>
              </li>
            </ul> */}
            <ul className="navbar-nav ml-auto right_list"> 
              {/* <li className='nav-item'> 
                <div className='progress_content'>
                   <div style={{ width: 40, margin: "0 auto" }}>
                    <CircularProgressbar
                      value={30}
                      text={`${30}%`}
                      styles={buildStyles({
                        pathColor: "#FFB800",
                        textColor: "#333",
                        trailColor: "#FFF1CC",
                      })}
                    />
                  </div>
                  <div>
                    <h2>Quick Start</h2>
                    <p>6 still to go</p>
                  </div>
                </div> 
                 </li>   */}
                <li className="nav-item dropdown has-arrow account-item">
                  <Link to="/" className="dropdown-toggle" data-bs-toggle="dropdown">
                    <div className="user-infos">
                      <span className="user-img">
                        <img src="assets/img/profile.svg" alt="" /> 
                      </span> 
                    </div>
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end emp">
                    <Link className="dropdown-item" to="/profile">
                      <i className="feather-user me-2"></i> Profile
                    </Link> 
                  </div>
                </li> 

          
          </ul>
          </nav>
        </div>
      </div>
  
    </>
  )
}
export default Header;